import React, { useState, useEffect } from 'react';
import { FaStar, FaQuoteRight, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Sarah Johnson",
      role: "Marketing Manager",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face",
      text: "Chandan created the most beautiful portrait of my grandmother. The attention to detail and emotional depth in the artwork brought tears to my eyes. It's now the centerpiece of our living room.",
      rating: 5
    },
    {
      id: 2,
      name: "Michael Chen",
      role: "Business Owner",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face",
      text: "I commissioned Chandan for our company's logo design and couldn't be happier. He understood our vision perfectly and delivered something beyond our expectations. Professional and talented!",
      rating: 5
    },
    {
      id: 3,
      name: "Emily Rodriguez",
      role: "Event Planner",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face",
      text: "The wedding illustrations Chandan created for our special day were absolutely stunning. Every guest commented on how beautiful they were. He captured our love story perfectly.",
      rating: 5
    },
    {
      id: 4,
      name: "David Thompson",
      role: "Pet Owner",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face",
      text: "I wanted a portrait of my beloved dog who passed away. Chandan's work was so lifelike and captured his personality perfectly. It's a treasure I'll cherish forever.",
      rating: 5
    },
    {
      id: 5,
      name: "Lisa Wang",
      role: "Art Collector",
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face",
      text: "Chandan's digital illustrations are simply breathtaking. The creativity and technical skill are evident in every piece. I've commissioned multiple works and each one is unique and beautiful.",
      rating: 5
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
  };

  return (
    <section id="testimonials" className="section testimonials">
      <div className="container">
        <div className="section-title">
          <h2>What Clients Say</h2>
          <p>Hear from satisfied customers who love their custom artwork</p>
        </div>

        <div className="testimonials-container">
          <div className="testimonial-card">
            <div className="testimonial-content">
              <div className="quote-icon"><FaQuoteRight /></div>
              <p className="testimonial-text">
                {testimonials[currentTestimonial].text}
              </p>
              <div className="testimonial-rating">
                {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                  <FaStar key={i} className="star" />
                ))}
              </div>
            </div>
            
            <div className="testimonial-author">
              <img 
                src={testimonials[currentTestimonial].image} 
                alt={testimonials[currentTestimonial].name}
                className="author-image"
              />
              <div className="author-info">
                <h4>{testimonials[currentTestimonial].name}</h4>
                <p>{testimonials[currentTestimonial].role}</p>
              </div>
            </div>
          </div>

          <div className="testimonial-controls">
            <button className="control-btn prev" onClick={prevTestimonial}>
              <FaChevronLeft />
            </button>
            <button className="control-btn next" onClick={nextTestimonial}>
              <FaChevronRight />
            </button>
          </div>

          <div className="testimonial-dots">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentTestimonial ? 'active' : ''}`}
                onClick={() => goToTestimonial(index)}
              />
            ))}
          </div>
        </div>

        <div className="testimonials-stats">
          <div className="stat-item">
            <h3>200+</h3>
            <p>Happy Clients</p>
          </div>
          <div className="stat-item">
            <h3>500+</h3>
            <p>Artworks Created</p>
          </div>
          <div className="stat-item">
            <h3>5.0</h3>
            <p>Average Rating</p>
          </div>
          <div className="stat-item">
            <h3>100%</h3>
            <p>Satisfaction Rate</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
